// dbext:profile=staging_mcdo2019_be
import $      from "jquery";
import Cleave from 'cleave.js';

import admin_crud    from "./910-admin_crud.js";

/*

show tables;
select * from 210_opening_hours;

*/

export default {

    init_opening_hours()
    {
        // reset all input elements
        $('.js-opho input[type="checkbox"]').prop( 'checked', false );
        $('.js-opho input[type="text"]'    ).val('');

        // event handlers
        $('.js-sync-to-gmb').on( 'click', this.on__sync_to_gmb__click() );

        { // set HH:MM time masks
            for ( let open_time of $('.js-opho input[type="text"]' ) ){

                new Cleave( open_time, {
                    time        : true,
                    timePattern : ['h', 'm'],
                } );
            }
        }

        // editing existing data? ⇒ show current data
        if ( g_mode === 'update' ){

            let de_opho = $('.js-opho');
            for ( let r of g_restaurant.opening_hours ){

                // e.g. js-open-from--1
                de_opho.find( '.js-opho__weekday--' + r.weekday + ' .js-open-from--'  + r.i_weekday ).val( r.open_from  );
                de_opho.find( '.js-opho__weekday--' + r.weekday + ' .js-open-until--' + r.i_weekday ).val( r.open_until );
            }
        }

    },

    validate_input()
    {
        $('.js-opho__table .is-error').removeClass( 'is-error' );
        let there_are_errors = false;

        { // check HH:MM values
            let de_hh_mms = $('.js-opho__table input[placeholder="hh:mm"]').toArray();
            for ( let de_hh_mm of de_hh_mms ){

                // jquerify
                de_hh_mm = $(de_hh_mm);

                // empty? ⇒ ok, take next
                if ( de_hh_mm.val() == '' ){
                    continue;
                }

                // hh:mm
                if ( ! de_hh_mm.val().match( /^\d\d:\d\d$/ ) ){
                    there_are_errors = true;
                    de_hh_mm.addClass( 'is-error' );
                    continue;
                }
            }
        }

        { // validate all duo's: [ open from | open until ]
            let de_duos = $('.js-from-until-duo');
            for ( let de_duo of de_duos ){

                // jquerify
                de_duo = $(de_duo);

                let de_open_from  = de_duo.find( '.js-open-from'  );
                let de_open_until = de_duo.find( '.js-open-until' );

                let open_from  = de_open_from.val();
                let open_until = de_open_until.val();

                if ( // both should be set
                        (   open_from && ! open_until )
                     || ( ! open_from &&   open_until )
                   ){
                    de_open_from .addClass( 'is-error' );
                    de_open_until.addClass( 'is-error' );
                    there_are_errors = true;
                    continue;
                }

                // from > until ⇒ error
                if ( open_from > open_until ){
                   de_open_from .addClass( 'is-error' );
                   de_open_until.addClass( 'is-error' );
                   there_are_errors = true;
                }

                // until should be max 23:59
                if ( open_until == '00:00' ){
                   de_open_until.addClass( 'is-error' );
                   there_are_errors = true;
                }
            }
        }

        let validated = ! there_are_errors;
        return validated;
    },

    async on__form__submit( g_mode, restaurant_id )
    {
        var records = this.collect_opening_hours( restaurant_id );

        // updating? ⇒ delete existing records
        if ( g_mode === 'update' ){

            // delete the opening hours of the restaurant
            await this.delete_opening_hours_of_restaurant( restaurant_id );
        }

        // insert records in tables
        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '210_opening_hours', 'insert' ), {
                data : r,
            } );
        }
    },

    async delete_opening_hours_of_restaurant( restaurant_id )
    {
        // load records to delete
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '210_opening_hours', 'select_where' ), {
                'where' : {
                    'restaurant_id': restaurant_id,
                }
            } );
            return response.data;
        })();

        // delete records
        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '210_opening_hours', 'delete' ), {
                ids : {
                    id : r.id
                },
            } );
        }
    },

    collect_opening_hours( restaurant_id = null )
    {
        var records = [];

        { // collect opening hours data in records[]

            let de_opho = $('.js-opho');

            for ( let weekday of [ 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday' ] ){

                for ( let i of [ 1, 2 ] ){

                    let de_open_from  = de_opho.find( `.js-opho__weekday--${weekday} .js-open-from--${i} ` );
                    let de_open_until = de_opho.find( `.js-opho__weekday--${weekday} .js-open-until--${i}` );

                    let open_from  = de_open_from .val().trim();
                    let open_until = de_open_until.val().trim();

                    // don't save incomplete rows
                    if ( ! open_from || ! open_until ){
                        continue;
                    }

                    records.push( {
                        restaurant_id : restaurant_id ,
                        weekday       : weekday       ,
                        open_from     : open_from     ,
                        open_until    : open_until    ,
                    } );
                }
            }
        }

        return records;
    },

    on__sync_to_gmb__click()
    {
        return async ( e ) => {
            e.preventDefault();

            let de_sync   = $('.c-sync');
            let de_ok     = $('.c-synced.c-synced--ok');
            let de_errors = $('.c-synced.c-synced--errors');

            if ( ! this.validate_input() ){
                return;
            }

            // start the spinner
            de_sync.addClass( 'is-spinning' );

            // get gmb_location_id + structure check
            let gmb_location_id = $('input[name="gmb_location_id"]').val();
            if ( ! gmb_location_id || ! gmb_location_id.match( /^accounts\/\d+\/locations\/\d+$/ ) ){
                alert( 'ERROR: invalid GMB location id' );
                de_sync.removeClass( 'is-spinning' );
                de_errors.show();
                de_errors.fadeOut('slow');
                return;
            }

            // get opening hours
            let opening_hours = this.collect_opening_hours();

            // ajax sync to GMB
            let response = await
            admin_crud.POST( '/en/admin/gmb-sync-opening-hours', {
                location_id   : gmb_location_id ,
                opening_hours : opening_hours   ,
            });

            // error? ⇒ show it
            if ( response.data.error ){
                alert( response.data.error );
                de_sync.removeClass( 'is-spinning' );
                de_errors.show();
                de_errors.fadeOut('slow');
                return;
            }

            // ok
            de_sync.removeClass( 'is-spinning' );
            de_ok.show();
            de_ok.fadeOut('slow');
        };
    }

}


